import React, { Component } from "react";
import { Image, Spinner, ListGroup } from "react-bootstrap";
import { refs } from "../../_helpers/refs";

import axiosInstance from "../../_helpers/axiosConfig";

import NumberFormat from "react-number-format";
import Instructions from "./Instructions";
import VerifyPhone from "./VerifyPhone";
import MoreInfo from "./MoreInfo";
import moment from "moment";

import "./style.css";

export default class ReservationForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        phoneNumber: "",
        phoneFormatted: "",
        allowSms: null,
        groupCode: "",
        terms: false,
        verifyCode: "",
        showVerify: false,
        submitting: false,
        errors: [],
      };
    this.validate = this.validate.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
        this.props.shouldBlock();
    }
  }

  validate(e) {
    e.preventDefault();

    let errors = {};
    let phoneNumber = this.state.phoneNumber.replace(/\D/g, "");

    if (this.state.firstName.length === 0) {
      errors.firstName = "First name is required.";
    }

    if (this.state.lastName.length === 0) {
      errors.lastName = "Last name is required.";
    }

    if (phoneNumber.length !== 10) {
      errors.phoneNumber = "Phone Number is required.";
    }

    if (this.state.allowSms === null) {
      errors.allowSms = "Please answer either yes or no.";
    }

    if (this.state.groupCode.length === 0) {
      errors.groupCode = "Group code is required.";
    }

    if (this.state.groupCode.toUpperCase() === "RCHALL" || 
        this.state.groupCode.toUpperCase() === "RCHJJ") 
      {
      const age = moment().diff(
        moment(this.state.dateOfBirth, "MMDDYYYY"),
        "years"
      );
      if (age < 18) {
        errors.dateOfBirth =
          `You must be 18 years old or older when using ${this.state.groupCode.toUpperCase()} group code.`;
      }
    }

    if (this.state.groupCode.toUpperCase() === "URYOUTH" ||
        this.state.groupCode.toUpperCase() === "BHAWKS" ||
        this.state.groupCode.toUpperCase() === "TERRIERS" ||
        this.state.groupCode.toUpperCase() === "WILDCATS") 
      {
      const age = moment().diff(
        moment(this.state.dateOfBirth, "MMDDYYYY"),
        "years"
      );
      if (age > 17) {
        errors.dateOfBirth =
          `You must be 17 years old or younger when using ${this.state.groupCode.toUpperCase()} group code.`;
      }
    }

    if (this.state.terms === false) {
      errors.terms = "Please agree to the terms of consent.";
    }

    if (this.state.dateOfBirth.length === 0) {
      errors.dateOfBirth = "Date of Birth is required";
    } else if (this.state.dateOfBirth.replace(/\D/g, "").length !== 8) {
      errors.dateOfBirth = "Invalid format: Ex: 03/15/1980.";
    } else if (!moment(this.state.dateOfBirth, "MM/DD/YYYY").isValid()) {
      errors.dateOfBirth = "Date of Birth is not valid.";
    } else if (moment().diff(moment(this.state.dateOfBirth, "MMDDYYYY"), 'years') < 12) {
      errors.dateOfBirth = "You must be 12 years old or older.";
    }

    this.setState({ errors }, function () {
      this.scrollToError();
    });

    if (
      !errors.firstName &&
      !errors.lastName &&
      !errors.phoneNumber &&
      !errors.dateOfBirth &&
      !errors.allowSms &&
      !errors.groupCode &&
      !errors.terms
    ) {
      if (this.state.allowSms && !this.state.showVerify) {
        this.setState({ submitting: true }, function () {
          this.sendVerifactionCode();
        });
      } else {
        this.setState({ submitting: true }, function () {
          this.submitReservation();
        });
      }
    }
  }

  scrollToError = () => {
    for (const ref in refs) {
      if (ref in this.state.errors) {
        refs[ref].current.scrollIntoView();
        window.scrollBy(0, -200);
        break;
      }
    }
  };

  renderValidateMessage(field) {
    const message = this.state.errors[field];
    return (
      <div id={`${field}-error`} className="text-danger hide">
        {message}
      </div>
    );
  }

  sendVerifactionCode() {
    axiosInstance
      .request({
        method: "POST",
        url: `/vaccine/verification-code`,
        data: {
          phoneNumber: this.state.phoneNumber,
        },
      })
      .then((response) => {
        this.setState({ submitting: false });
        this.handleShowVerify();
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data.errors,
          submitting: false,
        });
      });
  }

  submitReservation() {
    const date = this.state.dateOfBirth.split("/");
    const dateOfBirth = date[2] + "-" + date[0] + "-" + date[1];

    axiosInstance
      .request({
        method: "POST",
        url: `/vaccine/reservation`,
        data: {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dateOfBirth: dateOfBirth,
          phoneNumber: this.state.phoneNumber,
          allowSms: this.state.allowSms,
          groupCode: this.state.groupCode,
          terms: this.state.terms,
          verificationCode: this.state.verifyCode,
        },
      })
      .then((response) => {
        this.props.redirect();
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data.errors,
          submitting: false,
        });
      });
  }

  handleSubmitText() {
    if (this.state.submitting && this.state.allowSms) {
      return (
        <span>
          <Spinner animation="border" size="sm" /> Sending...
        </span>
      );
    } else if (this.state.submitting) {
      return (
        <span>
          <Spinner animation="border" size="sm" /> Submitting...
        </span>
      );
    } else if (this.state.allowSms && !this.state.showVerify) {
      return <span>Send verification code</span>;
    } else {
      return <span>Register</span>;
    }
  }

  handleEnter = (e) => {
    if (e.keyCode === 13) {
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index + 1].focus();
      e.preventDefault();
    }
  };

  handleShowVerify = () => {
    this.setState({ showVerify: true });
  };

  handleCloseVerify = () => {
    this.setState({ showVerify: false });
  };

  handlePhoneFormat = (number) => {
    this.setState({ phoneFormatted: number });
  };

  handleSetVerify = (code) => {
    this.setState({ verifyCode: code });
  };

  handleSetErrors = (errors) => {
    this.setState({ errors: errors }, function () {
      this.scrollToError();
    });
  };

  render() {
    return <div>
        <div className="rch-logo-mobile text-center">
          <Image src="https://axs-media.s3.amazonaws.com/rch.png" fluid />
        </div>
        <div className="row reservation-form-container h-100">
          <div className="col my-auto">
            <div className="card shadow mb-5">
              <div className="row">
                <div className="col-lg-6 col-sm-12 instructions-container">
                  <Instructions />
                </div>
                <div className="col-lg-6 col-sm-12 mt-4">
                  <form>
                    <div className="row">
                      <div className="col">
                        <div ref={refs.firstName} className="form-group">
                          <label>
                            <span className="text-danger">*</span> First Name
                          </label>
                          <input
                            type="text"
                            name="FirstName"
                            onKeyDown={this.handleEnter}
                            value={this.state.firstName}
                            placeholder="First Name"
                            className="form-control"
                            onChange={(e) =>
                              this.setState({
                                firstName: e.target.value.trim(),
                              })
                            }
                          />
                          {this.renderValidateMessage("firstName")}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div ref={refs.lastName} className="form-group">
                          <label>
                            <span className="text-danger">*</span> Last Name
                          </label>
                          <input
                            type="text"
                            name="LastName"
                            onKeyDown={this.handleEnter}
                            value={this.state.lastName}
                            placeholder="Last Name"
                            className="form-control"
                            onChange={(e) =>
                              this.setState({
                                lastName: e.target.value.trim(),
                              })
                            }
                          />
                          {this.renderValidateMessage("lastName")}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div ref={refs.dateOfBirth} className="form-group">
                          <label>
                            <span className="text-danger">*</span> Date of Birth
                          </label>
                          <NumberFormat
                            onValueChange={(e) =>
                              this.setState({ dateOfBirth: e.formattedValue })
                            }
                            onKeyDown={this.handleEnter}
                            value={this.state.dateOfBirth}
                            format="##/##/####"
                            mask="_"
                            name="dateOfBirth"
                            className="form-control"
                            placeholder="__/__/____"
                          />
                          {this.renderValidateMessage("dateOfBirth")}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div ref={refs.phoneNumber} className="form-group">
                          <label>
                            <span className="text-danger">*</span> Phone Number
                            &nbsp;
                          </label>
                          <NumberFormat
                            onValueChange={(e) => {
                              this.setState({
                                phoneNumber: e.value,
                              });
                              this.handlePhoneFormat(e.formattedValue);
                            }}
                            onKeyDown={this.handleEnter}
                            value={this.state.phoneNumber}
                            format="###-###-####"
                            mask="_"
                            name="phone"
                            className="form-control"
                            placeholder="___-___-____"
                          />
                          {this.renderValidateMessage("phoneNumber")}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div ref={refs.allowSms} className="col pt-2">
                        <label>
                          <span className="text-danger">*</span> Can we contact
                          you via text message?&nbsp;
                          <MoreInfo type="question" showOn={["hover", "focus"]}>
                            Save time by allowing us to send you a pre vaccine
                            questionnaire to complete prior to your appointment
                            date.&nbsp;
                            <small>
                              <b>
                                We will never spam you and will only contact you
                                regarding your COVID-19 vaccination{" "}
                              </b>
                            </small>
                          </MoreInfo>
                        </label>
                        <div className="form-check px-0 pb-3 pt-2">
                          <ListGroup horizontal>
                            <ListGroup.Item
                              action
                              href="#yes"
                              className="text-center"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  allowSms: true,
                                });
                              }}
                            >
                              Yes
                            </ListGroup.Item>
                            <ListGroup.Item
                              action
                              href="#no"
                              className="text-center"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  allowSms: false,
                                  showVerify: false,
                                  verifyCode: "",
                                });
                              }}
                            >
                              No
                            </ListGroup.Item>
                          </ListGroup>

                          {this.renderValidateMessage("allowSms")}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div ref={refs.groupCode} className="form-group">
                          <label>
                            <span className="text-danger">*</span> Group Code
                          </label>
                          <input
                            type="text"
                            name="GroupCode"
                            onKeyDown={this.handleEnter}
                            value={this.state.groupCode}
                            className="form-control"
                            placeholder="Group Code"
                            onChange={(e) =>
                              this.setState({
                                groupCode: e.target.value.trim(),
                              })
                            }
                          />
                          {this.renderValidateMessage("groupCode")}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div
                          ref={refs.terms}
                          className="form-group form-check py-4"
                        >
                          <input
                            type="checkbox"
                            value={this.state.terms}
                            style={{ cursor: "pointer" }}
                            checked={this.state.terms}
                            onKeyDown={this.handleEnter}
                            className="form-check-input"
                            onChange={(e) =>
                              this.setState((state) => ({
                                terms: !state.terms,
                              }))
                            }
                          />
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) =>
                              this.setState((state) => ({
                                terms: !state.terms,
                              }))
                            }
                          >
                            <span className="text-danger">*</span>I understand
                            vaccines are limited supply and an appointment will
                            be scheduled based on availability.
                          </span>
                          {this.renderValidateMessage("terms")}
                        </div>
                      </div>
                    </div>

                    <VerifyPhone
                      show={this.state.showVerify}
                      close={this.handleCloseVerify}
                      redirect={this.props.redirect}
                      setVerify={this.handleSetVerify}
                      showError={this.renderValidateMessage("verificationCode")}
                      verifyCode={this.state.verifyCode}
                      {...this.state}
                    />

                    <div className="row">
                      <div className="col">
                        <div className="form-group col px-0">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={this.validate}
                            disabled={this.state.submitting}
                          >
                            {this.handleSubmitText()}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
}
